import { useContext, useState } from "react";
import CreateRole from "./components/CreateRole";
import DeleteRole from "./components/DeleteRole";
import { useQuery } from "@tanstack/react-query";
import { handleFetchRoles } from "../../api/matrix";

import Something from "../../components/shared/Something";
import CreateLevel from "./components/CreateLevel";
import UpdateLevel from "./components/UpdateLevel";
import DeleteLevel from "./components/DeleteLevel";
import { Button, Collapse, Popover } from "antd";
import UpdateRole from "./components/UpdateRole";
import groupRoles from "../../utils/groupRoles";
import Error from "../../components/shared/Error";
import {
  DatabaseOutlined,
  DeleteOutlined,
  EditFilled,
  MinusCircleFilled,
  MoreOutlined,
  PlusCircleFilled,
  UserOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../../contexts/AuthContext";

export default function Roles() {
  const { user } = useContext(AuthContext);
  const [createItemModal, setCreateItemModal] = useState<boolean>(false);
  const [addLevelModal, setAddLevelModal] = useState<boolean>(false);
  const [updateLevelModal, setUpdateLevelModal] = useState<boolean>(false);
  const [deleteLevelModal, setDeleteLevelModal] = useState<boolean>(false);

  const [updateRoleModal, setUpdateRoleModal] = useState<boolean>(false);
  const [deleteRoleModal, setDeleteRoleModal] = useState<boolean>(false);

  const [selectedLevel, setSelectedLevel] = useState<any>({});
  const [selectedRole, setSelectedRole] = useState<any>({});
  const [selectedCode, setSelectedCode] = useState<any>({});
  const adminAccess = [9];

  const {
    data: roles,
    refetch,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["roles"],
    queryFn: handleFetchRoles,
  });

  if (!adminAccess.includes(user?.accessLevel)) {
    return <Error error="You are not authorized to access this page" />;
  }

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex justify-between border p-2">
          <div className="">
            <div className="font-bold text-lg">Matrix</div>
            <div className="text-gray-600">Roles Matrix</div>
          </div>
          <div className="">
            {adminAccess.includes(user?.accessLevel) && (
              <button
                onClick={() => setCreateItemModal(true)}
                className="flex mx-2 justify-center items-center border px-4 h-8 bg-karimjee hover:bg-karimjee-dark text-white shadow-sm"
              >
                + New
              </button>
            )}
          </div>
        </div>

        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="p-2 border">
            <div className="pb-4">
              {roles?.map((role: any, index: number) => (
                <Collapse
                  bordered={false}
                  size="small"
                  key={index}
                  ghost
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <MinusCircleFilled size={15} />
                    ) : (
                      <PlusCircleFilled size={15} />
                    )
                  }
                  items={[
                    {
                      key: 1,
                      label: (
                        <div
                          className="grid grid-cols-12 border  bg-gray-100"
                          style={{ fontSize: 12 }}
                        >
                          <div className="col-span-12 sm:col-span-5 flex items-center justify-between px-4">
                            <div className="flex items-center">
                              <div className="flex items-center">
                                <div className="mx-1">{index + 1}.</div>
                                <UserOutlined />
                                <div className="mx-2 font-bold flex items-center">
                                  {role?.name}{" "}
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center">
                              {role?.isReport && (
                                <div className="flex items-center mx-1 text-blue-700">
                                  <DatabaseOutlined />
                                  <span className="mx-1">Report</span>
                                </div>
                              )}
                              ({role?.min} - {role?.max})
                            </div>
                          </div>

                          <div className="col-span-12 sm:col-span-7  px-4">
                            <div className="flex justify-between items-center">
                              <div className="">Module Description</div>
                              <div className="flex items-center">
                                <button
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    setSelectedCode(role);
                                    setAddLevelModal(true);
                                  }}
                                  className="border border-gray-300 p-1 m-1 bg-gray-200 hover:bg-gray-300 rounded-md shadow-sm"
                                >
                                  + Add Module Level
                                </button>
                                <button>
                                  <Popover
                                    placement="leftBottom"
                                    title={"Action"}
                                    content={
                                      <div className="flex">
                                        <button
                                          onClick={(e: any) => {
                                            e.stopPropagation();
                                            setSelectedRole(role);
                                            setUpdateRoleModal(true);
                                          }}
                                          className="border py-1 px-2 mx-1 flex items-center bg-green-50 text-green-800 shadow-sm"
                                        >
                                          <EditFilled />
                                          <span className="mx-1">
                                            Edit Role
                                          </span>
                                        </button>
                                        <button
                                          onClick={(e: any) => {
                                            e.stopPropagation();
                                            setSelectedRole(role);
                                            setDeleteRoleModal(true);
                                          }}
                                          className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
                                        >
                                          <DeleteOutlined />
                                          <span className="mx-1">
                                            Delete Role
                                          </span>
                                        </button>
                                      </div>
                                    }
                                  >
                                    <Button
                                      onClick={(e: any) => e.stopPropagation()}
                                      className="shadow-sm"
                                    >
                                      <MoreOutlined />
                                    </Button>
                                  </Popover>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                      children: (
                        <div className="-mt-6 mx-7">
                          <div className="">
                            {groupRoles(role?.levels, "moduleName")?.map(
                              (level: any, index: number) => (
                                <Collapse
                                  bordered={false}
                                  size="small"
                                  key={index}
                                  ghost
                                  expandIcon={({ isActive }) =>
                                    isActive ? (
                                      <MinusCircleFilled />
                                    ) : (
                                      <PlusCircleFilled />
                                    )
                                  }
                                  items={[
                                    {
                                      key: 1,
                                      label: (
                                        <div className="flex justify-between">
                                          <div className="">{level?.code}</div>
                                          <div className="">
                                            <div className="flex text-gray-600">
                                              Highest Level :
                                              <div className="w-8 text-right">
                                                {level?.level}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ),
                                      children: (
                                        <div
                                          className="-mt-4 border"
                                          style={{ fontSize: 12 }}
                                        >
                                          <div className="grid grid-cols-12">
                                            <div className="col-span-12 sm:col-span-3 border-r border-b  px-4">
                                              Module
                                            </div>
                                            <div className="col-span-12 sm:col-span-3 px-4   border-r border-b">
                                              Permission Level
                                            </div>
                                            <div className="col-span-12 sm:col-span-5  border-r border-b  px-4">
                                              Module Description
                                            </div>
                                            <div className="col-span-12 sm:col-span-1  border-b  px-4">
                                              Actions
                                            </div>
                                          </div>
                                          {level?.items?.map(
                                            (item: any, index: number) => (
                                              <div
                                                className="grid grid-cols-12 "
                                                key={index}
                                              >
                                                <div className="col-span-12 sm:col-span-3 border-r border-b    px-4">
                                                  {item?.moduleCode}
                                                </div>
                                                <div className="col-span-12 sm:col-span-3 border-r border-b    px-4 ">
                                                  {item?.level}
                                                </div>
                                                <div className="col-span-12 sm:col-span-5 border-r border-b  px-4">
                                                  <div className="flex justify-between">
                                                    <div className="">
                                                      <div className="">
                                                        {item?.description}
                                                      </div>
                                                      {item?.hasMore && (
                                                        <div className="mx-2">
                                                          <div className="">
                                                            <div className="italic font-bold">
                                                              Procedures:
                                                            </div>
                                                            <div className="italic text-gray-500">
                                                              {item?.procedures}
                                                            </div>
                                                          </div>
                                                          <img
                                                            src={item?.imageUrl}
                                                            alt=""
                                                            width={"100%"}
                                                          />
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-span-12 sm:col-span-1 border-b  px-4">
                                                  <div className="flex">
                                                    <button
                                                      onClick={() => {
                                                        setSelectedRole(role);
                                                        setSelectedLevel(item);
                                                        setUpdateLevelModal(
                                                          true
                                                        );
                                                      }}
                                                      className="border py-1 px-2 mx-1 flex items-center bg-green-50 text-green-800"
                                                    >
                                                      <EditFilled />
                                                    </button>
                                                    <button
                                                      onClick={() => {
                                                        setSelectedRole(role);
                                                        setSelectedLevel(item);
                                                        setDeleteLevelModal(
                                                          true
                                                        );
                                                      }}
                                                      className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800"
                                                    >
                                                      <DeleteOutlined />
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      ),
                                    },
                                  ]}
                                ></Collapse>
                              )
                            )}
                          </div>
                        </div>
                      ),
                    },
                  ]}
                ></Collapse>
              ))}
            </div>
          </div>
        )}
      </div>

      <CreateRole
        isVisible={createItemModal}
        setVisible={setCreateItemModal}
        refetch={refetch}
      />

      <UpdateRole
        isVisible={updateRoleModal}
        setVisible={setUpdateRoleModal}
        selectedRole={selectedRole}
      />

      <DeleteRole
        isVisible={deleteRoleModal}
        setVisible={setDeleteRoleModal}
        selectedRole={selectedRole}
      />

      <CreateLevel
        isVisible={addLevelModal}
        setVisible={setAddLevelModal}
        selected={selectedCode}
      />

      <UpdateLevel
        isVisible={updateLevelModal}
        setVisible={setUpdateLevelModal}
        selectedLevel={selectedLevel}
        selectedRole={selectedRole}
      />

      <DeleteLevel
        isVisible={deleteLevelModal}
        setVisible={setDeleteLevelModal}
        selectedLevel={selectedLevel}
        selectedRole={selectedRole}
      />
    </div>
  );
}
